import {safeCaptureException} from '../utils/sentry';
import {API, type UpdateIvIntentPayload} from '@chekin/api';
import {type CoreError, type IVIntent} from '@chekin/core';
import {useMutation} from '@tanstack/react-query';

type Props = {
  postHandler?: () => void;
  onSuccess?: (data: IVIntent) => void;
};
export const useUpdateIvIntent = ({onSuccess, postHandler}: Props = {}) => {
  const {
    mutate: sendUpdateIvIntentRequest,
    mutateAsync: sendUpdateIvIntentRequestAsync,
    isPending,
  } = useMutation<IVIntent, CoreError, UpdateIvIntentPayload>({
    mutationFn: payload => API.identityVerification.updateIvIntent(payload),
    onError: error => {
      safeCaptureException(error, 'Updating the IV intent');
    },
    onSuccess: data => {
      onSuccess?.(data);
    },
    onSettled: postHandler,
  });

  return {
    isLoading: isPending,
    sendUpdateIvIntentRequest,
    sendUpdateIvIntentRequestAsync,
  };
};
